import {
  EBOOK_ATTRIBUTION_COOKIE,
  EBOOK_ATTRIBUTION_MAX_AGE_SECONDS,
  type EbookAttributionInput,
  type EbookAttributionRecord,
} from "@/lib/ebook-attribution";

const PARAMS_KEY = "cc.p";
const FIRST_TOUCH_KEY = "cc.ft";

export function captureFirstTouchAttribution() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    if (!localStorage.getItem(FIRST_TOUCH_KEY)) {
      localStorage.setItem(
        FIRST_TOUCH_KEY,
        JSON.stringify({
          landing_page: window.location.pathname,
          referrer: document.referrer || "",
          captured_at: new Date().toISOString(),
        }),
      );
    }
  } catch {
    // Ignore storage failures.
  }
}

export function readStoredAttribution(): Record<string, string> {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const params = JSON.parse(localStorage.getItem(PARAMS_KEY) || "{}");
    const firstTouch = JSON.parse(localStorage.getItem(FIRST_TOUCH_KEY) || "{}");
    return {
      ...firstTouch,
      ...params,
    };
  } catch {
    return {};
  }
}

export function mergeClientAttribution(
  extra: Record<string, unknown> = {},
): Record<string, unknown> {
  return {
    ...readStoredAttribution(),
    ...extra,
  };
}

/**
 * Persist non-identifying ebook conversion context so later enquiries,
 * checkout starts and enrolments can be joined back to the download.
 */
export function recordEbookDownloadAttribution(
  record: EbookAttributionInput,
) {
  if (typeof window === "undefined") {
    return;
  }

  const value: EbookAttributionRecord = {
    ebook_slug: record.ebookSlug,
    ebook_title: record.ebookTitle,
    ebook_funnel_role: record.ebookFunnelRole,
    ebook_landing_page: record.ebookLandingPage,
    ebook_downloaded_at: new Date().toISOString(),
  };

  try {
    const params = JSON.parse(localStorage.getItem(PARAMS_KEY) || "{}");
    localStorage.setItem(
      PARAMS_KEY,
      JSON.stringify({ ...params, ...value }),
    );

    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${EBOOK_ATTRIBUTION_COOKIE}=${encodeURIComponent(
      JSON.stringify(value),
    )}; Max-Age=${EBOOK_ATTRIBUTION_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
  } catch {
    // Ignore storage and cookie failures; conversion should still complete.
  }
}
